import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const WhatIsEcoversity = () => (
  <section id="ecoversity" className="border-b border-border py-28 lg:py-36" data-testid="ecoversity-section">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-5">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-primary">Ecoversity</p>
        <h2 className="mt-6 font-display text-4xl font-bold leading-tight tracking-tight text-foreground sm:text-5xl" data-testid="ecoversity-heading">
          What is an <span className="text-primary">Ecoversity?</span>
        </h2>
      </div>
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
        className="space-y-6 text-base leading-relaxed text-foreground/80 sm:text-lg lg:col-span-7">
        <p className="font-display text-2xl font-medium leading-snug text-foreground sm:text-3xl" data-testid="ecoversity-definition">
          An ecoversity is a learning community that reimagines higher education around the wellbeing of people, communities,
          and the Earth.
        </p>
        <p>Learning grows through lived experience, cultural knowledge, creative practice, and relationships with people and place.</p>
        <p>
          The Ecoversities Alliance connects communities around the world exploring these possibilities. Each ecoversity takes
          its own shape, rooted in its local context and diverse ways of knowing.
        </p>
        <p className="border-l-4 border-gold pl-6 text-foreground" data-testid="ecoversity-nia-meaning">
          At Nia, this means bringing learning, healing, and contribution together as we grow into who we are and deepen our
          responsibility to the world we share.
        </p>
        <a href="https://ecoversities.org/" target="_blank" rel="noopener noreferrer" data-testid="ecoversities-alliance-link"
          className="group inline-flex items-center gap-3 pt-4 text-sm font-semibold text-primary underline decoration-gold decoration-2 underline-offset-8">
          Explore the Ecoversities Alliance
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </a>
      </motion.div>
    </div>
  </section>
);
